module.exports = __webpack_public_path__ + "media/images/userlistdummy-95d7eab11adeb22d5ed7654ff0c52444.png";